export default `
  mutation resetPasswordWithResultError($email: String!, $newPassword: String!, $resetPasswordToken: String!){
     resetPasswordWithResultError(email: $email, newPassword: $newPassword, resetPasswordToken: $resetPasswordToken) {
       result
       error_message
   }
  }
`;
